import axios from "axios";

const privacy_policy_form = {
  namespaced: true,
  state() {
    return {
      is_guest_allowed: true,
      is_owner_allowed: false,
    }
  },
  mutations: {
    setData(state, data) {
      if (data[0].is_guest_allowed === 1) {
        state.is_guest_allowed = true;
      } else {
        state.is_guest_allowed = false;
      }
      if (data[0].is_owner_allowed === 1) {
        state.is_owner_allowed = true;
      } else {
        state.is_owner_allowed = false;
      }
    },
  },
  actions: {
    load({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/management_companies/${payload.managementCompanyCode}/settings`).then((response) => {
          commit('setData', response.data.data);
          resolve(true);
        }).catch(() => reject());
      });
    },
  }
}

export default privacy_policy_form
